var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    style: "--resolution-x: ".concat(_vm.resolution[0], "; --resolution-y: ").concat(_vm.resolution[1]),
    attrs: {
      "id": "s-dynamsoft-barcode-scanner"
    }
  }, [_c('div', {
    ref: "scanner"
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }